const state = {
  route: 'network',
  icon: 'fas fa-network-wired',
  title: 'network',
  config: {
    address: '',
  }
}

const mutations = {
  setConfig(_state, config) {
    _state.config = config;
  }
}

const actions = {
  async read(context, { client, producer, event, data }) {
    // Fallback handler for disconnected devices
    if (!window.navigator.onLine) {
      return {
        message: 'reading_error_no_connection',
        type: 'error',
        voucher: null,
        data: ''
      }
    }

    try {
      const response = await this.$http.post(
        `/api/client/${client.id}/producer/${producer.id}/event/${event.id}/voucher`, 
        {
          data,
          sections: this.$store.state.sectors.selected.map(item => item.id)
        }
      )
      
      return {
        message: 'reading_success',
        type: 'success',
        voucher: response.data,
        data: ''
      }
    } catch (error) {
      return {
        type: 'error',
        error: error.response
      }
    }
  }
}

export const store = {
  namespaced: true,
  state,
  actions,
  mutations
}